export const SCRIBELY_MONTHLY_PRODUCT_PATH = 'scribely-tier-100-monthly';
export const SCRIBELY_YEARLY_PRODUCT_PATH = 'scribely-tier-100-annual';

export const PRODUCTS = [
  {
    path: SCRIBELY_YEARLY_PRODUCT_PATH,
    tagline: 'Annual payment of {{annualValue}}',
    displayMonthly: true,
    displayDiscountAgainst: SCRIBELY_MONTHLY_PRODUCT_PATH
  },
  {
    path: SCRIBELY_MONTHLY_PRODUCT_PATH,
    tagline: 'Monthly payment'
  }
];
